export default function PasswordStrength({ password }) {
  const calculateStrength = (pwd) => {
    if (!pwd) return { strength: 0, label: "", color: "" };

    let strength = 0;
    let feedback = [];

    // Critérios de força
    if (pwd.length >= 8) strength += 1;
    else feedback.push("Mínimo 8 caracteres");

    if (pwd.length >= 12) strength += 1;

    if (/[a-z]/.test(pwd)) strength += 1;
    else feedback.push("Adicione letras minúsculas");

    if (/[A-Z]/.test(pwd)) strength += 1;
    else feedback.push("Adicione letras maiúsculas");

    if (/[0-9]/.test(pwd)) strength += 1;
    else feedback.push("Adicione números");

    if (/[^a-zA-Z0-9]/.test(pwd)) strength += 1;
    else feedback.push("Adicione caracteres especiais (!@#$%...)");

    let label, color;
    if (strength <= 2) {
      label = "Fraca";
      color = "#dc3545";
    } else if (strength <= 4) {
      label = "Média";
      color = "#ffc107";
    } else if (strength <= 5) {
      label = "Forte";
      color = "#28a745";
    } else {
      label = "Muito Forte";
      color = "#0056b3";
    }

    return { strength, label, color, feedback };
  };

  const { strength, label, color, feedback } = calculateStrength(password);

  if (!password) return null;

  return (
    <div style={{ marginTop: "0.5rem" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.5rem" }}>
        <div style={{ 
          flex: 1, 
          height: "6px", 
          background: "var(--border)", 
          borderRadius: "3px",
          overflow: "hidden"
        }}>
          <div style={{
            width: `${(strength / 6) * 100}%`,
            height: "100%",
            background: color,
            transition: "all 0.3s ease",
            borderRadius: "3px"
          }} />
        </div>
        <span style={{ 
          fontSize: "0.85rem", 
          fontWeight: 600, 
          color: color,
          minWidth: "80px",
          textAlign: "right"
        }}>
          {label}
        </span>
      </div>
      {feedback.length > 0 && (
        <div style={{ fontSize: "0.8rem", color: "var(--text-secondary)" }}>
          <div style={{ marginTop: "0.25rem" }}>
            {feedback.map((item, index) => (
              <span key={index} style={{ display: "inline-block", marginRight: "0.5rem", marginBottom: "0.25rem" }}>
                • {item}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
